import { Flex, Label, Switch } from '@buffer-mono/popcorn'

import type { DayOfWeek } from '../../../hooks/usePostingSchedule'

import { DAY_OF_WEEK } from '../../../utils'

import styles from './ScheduleTableHeader.module.css'

import type { JSX } from 'react'

interface ScheduleTableHeaderProps {
  day: DayOfWeek
  paused: boolean
  onTogglePause: () => void
  disabled?: boolean
  isDayEmpty: boolean
  variant?: 'mobile' | 'desktop'
}

const ScheduleTableHeader = ({
  day,
  paused,
  onTogglePause,
  disabled = false,
  isDayEmpty,
  variant = 'desktop',
}: ScheduleTableHeaderProps): JSX.Element => {
  const disablePauseToggle = disabled
  const isMobile = variant === 'mobile'

  return (
    <Flex
      direction={isMobile ? 'row' : 'column'}
      align="center"
      justify={isMobile ? 'between' : 'center'}
      gap={isMobile ? undefined : 'md'}
      className={isMobile ? styles.headerMobile : styles.header}
      onClick={(e): void => {
        if (!isDayEmpty && e.target instanceof HTMLElement) {
          const isSwitch =
            e.target.closest('[role="switch"]') ||
            e.target.closest('label[for]')
          if (isSwitch) {
            e.stopPropagation()
          }
        }
      }}
    >
      <Label>{DAY_OF_WEEK[day]}</Label>
      <Flex align="center" gap="2xs" className={styles.switchRow}>
        {!isDayEmpty && (
          <>
            <Label
              className={
                isMobile ? styles.switchLabelHidden : styles.switchLabel
              }
            >
              {paused ? 'Off' : 'On'}
            </Label>
            <Switch
              size="small"
              checked={!paused}
              disabled={disablePauseToggle}
              onCheckedChange={onTogglePause}
              id={`${day}-schedule`}
              aria-label={`${paused ? 'Enable' : 'Disable'} ${
                DAY_OF_WEEK[day]
              } posting schedule`}
            />
          </>
        )}
      </Flex>
    </Flex>
  )
}

export { ScheduleTableHeader }
